import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeSelectIsZoomDisabled } from '../selectors/zoomDisabledSelectors';

/**
 * useZoomDisabled Hook
 *
 * Returns whether a layer is zoom-disabled (current zoom < layer.minZoom).
 * Does NOT auto-deactivate the layer — user intent (active state) is preserved
 * so the layer reappears automatically when zooming back in.
 *
 * @param layerId - The key of the layer in the Redux store
 * @returns boolean indicating whether the layer is zoom-disabled
 */
export function useZoomDisabled(layerId: string): boolean {
  const selectIsZoomDisabled = useMemo(
    () => makeSelectIsZoomDisabled(layerId),
    [layerId]
  );
  return useSelector(selectIsZoomDisabled);
}
